// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1qx57","content":"GlobalSearch_content__2W_6w"};